/** @jsx jsx */
import { jsx } from "theme-ui";
import Container from "../container";
import { Link } from "gatsby";
import CheckMarkImage from "../../images/check-mark-blue.svg";

const Pricing = ({ value }) => {
  return (
    <div
      sx={{
        background: "white",
        padding: "0px 0px 120px 0px",
      }}
    >
      <Container>
        <div
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            ".pricing-component": {
              "&.pricing-first": {
                marginBottom: ["40px", "40px", "0px"],
              },
              width: ["100%", "100%", "calc(50% - 22px)"],
              ".pricing-component-heading": {
                backgroundColor: "grayBG",
                border: "1px solid",
                borderBottom: "0px",
                borderColor: "primary",
                borderTopLeftRadius: "20px",
                borderTopRightRadius: "20px",
                padding: "20px 15px 20px 40px",
                fontSize: "20px",
                fontWeight: "500",
              },
              ".pricing-list": {
                border: "1px solid",
                borderBottomLeftRadius: "20px",
                borderBottomRightRadius: "20px",
                borderTop: "0px",
                padding: "30px 15px 30px 35px",
                ul: {
                  margin: "0px",
                  padding: "0px",
                  li: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    listStyle: "none",
                    color: "#262626",
                    fontSize: "16px",
                    fontWeight: "light",
                    marginBottom: "15px",
                    img: {
                      marginRight: "20px",
                    },
                  },
                  "li:last-child": {
                    marginBottom: "0px",
                  },
                },
              },
              ".pricing-link-holder": {
                display: "flex",
                justifyContent: "center",
                marginTop: "30px",
                a: {
                  variant: "buttons.primaryBlue",
                },
              },
            },
          }}
        >
          <div className="pricing-component pricing-first">
            <div className="pricing-component-heading">Everplans - Free</div>
            <div className="pricing-list">
              <ul>
                <li>
                  <img src={CheckMarkImage} alt="" />
                  Store up to 10 items
                </li>
                <li>
                  <img src={CheckMarkImage} alt="" />
                  Smart, algorithm-led guidance
                </li>
                <li>
                  <img src={CheckMarkImage} alt="" />
                  Limited access to content
                </li>
                <li>
                  <img src={CheckMarkImage} alt="" />
                  Secure sharing
                </li>
              </ul>
            </div>
            <div className="pricing-link-holder">
              <Link to="https://webapps.everplans.com/#/auth/sign-up">
                Sign up
              </Link>
            </div>
          </div>
          <div className="pricing-component">
            <div className="pricing-component-heading">
              Everplans Premium - $99.99/year
            </div>
            <div className="pricing-list">
              <ul>
                <li>
                  <img src={CheckMarkImage} alt="" />
                  Everything in Everplans Basic
                </li>
                <li>
                  <img src={CheckMarkImage} alt="" />
                  Add unlimited items to your Everplan
                </li>
                <li>
                  <img src={CheckMarkImage} alt="" />
                  Access to premium content
                </li>
                <li>
                  <img src={CheckMarkImage} alt="" />
                  More guidance and specialized checklists
                </li>
              </ul>
            </div>
            <div className="pricing-link-holder">
              <Link to="https://webapps.everplans.com/#/auth/sign-up">
                Sign up for Premium
              </Link>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Pricing;
